import SEO from "@/components/SEO";

export default function Refund() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-zinc-300">
      <SEO title="Refund &amp; Cancellation Policy — SourceDeck" description="7-day money-back guarantee. Cancel anytime. Full refund policy." path="/refund" />
      <div className="max-w-3xl mx-auto px-6 md:px-8 py-16 md:py-24">
        <a href="/" className="sd-label mb-8 inline-block hover:text-white transition-colors" data-testid="legal-back-home">← BACK TO SOURCEDECK</a>
        <div className="sd-label mb-3 text-[#FF3B30]">● LEGAL</div>
        <h1 className="font-display text-5xl md:text-6xl leading-tight tracking-tight mb-4">Refund &amp; Cancellation Policy</h1>
        <div className="font-mono text-xs text-zinc-500 mb-12">Last updated: February 2026 · Applies to all paid subscriptions</div>

        <div className="space-y-6 leading-relaxed">
          <section>
            <h2 className="font-display text-2xl mt-4 mb-3 text-white">7-day free trial — no card required</h2>
            <p>Every new user can start a 7-day Pro trial without entering payment details. You get unlimited AI, Sponsor Fit Score, and live YouTube analytics. When the trial ends, your account automatically drops to the Free tier — there is nothing to cancel.</p>
          </section>

          <section>
            <h2 className="font-display text-2xl mt-8 mb-3 text-white">7-day money-back guarantee (paid plans)</h2>
            <p>If you're not satisfied within 7 days of your first paid subscription payment, contact us and we will issue a full refund — no questions asked. Refunds are processed to the original payment method via Razorpay within 5–10 business days.</p>
            <p>The 7-day window applies to your very first purchase only. Renewal payments after that are non-refundable, but you can cancel anytime (see below).</p>
          </section>

          <section>
            <h2 className="font-display text-2xl mt-8 mb-3 text-white">Cancellation</h2>
            <ul className="space-y-2 list-none">
              <li><span className="font-mono text-xs text-zinc-500 mr-2">·</span>Cancel anytime from your account settings or by contacting support.</li>
              <li><span className="font-mono text-xs text-zinc-500 mr-2">·</span>On cancellation, you retain Pro access until the end of your current 30-day billing period.</li>
              <li><span className="font-mono text-xs text-zinc-500 mr-2">·</span>No further charges will be made after cancellation.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-2xl mt-8 mb-3 text-white">Non-refundable circumstances</h2>
            <ul className="space-y-2 list-none">
              <li><span className="font-mono text-xs text-zinc-500 mr-2">·</span>Renewal payments after your first 7-day window.</li>
              <li><span className="font-mono text-xs text-zinc-500 mr-2">·</span>Accounts terminated for violating our <a href="/terms" className="text-[#FF3B30] hover:underline">Terms of Service</a>.</li>
              <li><span className="font-mono text-xs text-zinc-500 mr-2">·</span>Charges arising from your abuse of AI credits or automated scraping.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-2xl mt-8 mb-3 text-white">How to request a refund</h2>
            <p>Email us via the <a href="/contact" className="text-[#FF3B30] hover:underline">Contact page</a> with your account email and Razorpay transaction ID. We reply within 24 hours on business days.</p>
          </section>

          <section>
            <h2 className="font-display text-2xl mt-8 mb-3 text-white">Chargebacks</h2>
            <p>Please contact us before initiating a chargeback with your bank — we can almost always resolve issues faster and cheaper for both of us.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
